import React from "react";

const WeatherIcon = ({ show }) => {
  return (
    <>
      <div onClick={show} className="icon weather">
        <span>Weather</span>
      </div>
    </>
  );
};

export default WeatherIcon;
